import React from "react";
import videoSample from "../../assets/Avatar/TPA.mp4";
import styles from "./AboutPage.module.css";
import { motion } from "framer-motion";
import img from "../../assets/Avatar/aboutus.png"

const About = () => {
  return (
    <div className={styles.aboutSection}>
      <motion.div 
        className={styles.titleContainer}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <h1 className={styles.title}>About Us</h1>
        <p className={styles.subtitle}>Transforming real estate experiences with innovative technology and personalized service</p>
      </motion.div>
      
      <motion.div 
        className={styles.header}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.2 }}
      >
        <p>
          FirstLand, Inc is a corporate company registered in the state of Florida. 
          Established in 2022 by Dvir Cohen, an MBA graduate, full-stack software developer,
          and an entrepreneur passionate about integrating technology and extends support to real estate professional. 
          FirstLand brings extensive expertise in business management, AI, and software development.
          The company operates from its headquarters in Tampa, Florida, and aims to establish itself as a 
          leader in the rapidly expanding PropTech industry by introducing advanced AI-driven tools.            
        </p>
        <motion.img
          src={img}
          alt="About FirstLand"
          className={styles.img}
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
        />
      </motion.div>
      
      <motion.div 
        className={styles.columnContainer}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.4 }}
      >
        <div className={styles.column}>
          <p>
            FirstLand understands that the real estate process can be
            overwhelming, confusing, and time-consuming. That's why we've
            developed cutting-edge AI technology that streamlines the entire
            process, making it faster, more efficient, and more enjoyable for
            everyone involved.
          </p>
          <p>
            Our AI-powered platform is designed to assist clients at every stage
            of the real estate process, whether they're looking to buy, sell, or
            rent. By harnessing the power of machine learning and natural
            language processing, we can quickly analyze vast amounts of data,
            providing our clients with valuable insights that help them make
            informed decisions.
          </p>
          <p>
            For buyers, our platform offers a personalized search experience
            that takes into account their unique preferences and priorities. Our
            AI algorithms can quickly filter through thousands of listings,
            presenting only the properties that are most likely to meet their
            needs. This saves time and reduces frustration, as buyers no longer
            have to sift through dozens of irrelevant listings.
          </p>
        </div>
        <div className={styles.column}>
          <p>
            For sellers, our platform provides a range of cutting-edge marketing
            tools that ensure their property stands out from the crowd. Our
            AI-powered listing optimizer can analyze data on past sales, local
            market trends, and buyer behavior to create compelling, customized
            property descriptions that attract more potential buyers.
          </p>
          <p>
            And for renters, our platform offers an intuitive, streamlined
            experience that simplifies the rental process. Our AI-powered
            chatbot can answer questions, provide property information, and even
            schedule showings, freeing up time for property managers to focus on
            other tasks.
          </p>
          <p>
            Our platform also provides real estate agents with a suite of
            powerful tools to help them close deals faster and more efficiently.
            By leveraging the power of AI, our platform can quickly analyze
            buyer and seller data, identify potential leads, and even suggest
            personalized marketing strategies. This allows real estate agents to
            focus their time and energy on building relationships with clients
            and closing deals, rather than on time-consuming administrative
            tasks. With FirstLand, real estate agents have the support they need
            to achieve faster and more successful results.
          </p>
        </div>
      </motion.div>
      <motion.p 
        className={styles.foot}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.6 }}
      >
        Our tech real estate company is transforming the real estate industry by
        leveraging cutting-edge technology to provide a seamless, efficient, and
        enjoyable experience for buyers, sellers, and renters. With our
        innovative approach, we're making the real estate process faster, more
        transparent, and more accessible for everyone. Join us on our journey to
        revolutionize the way people buy, sell, and rent properties.
      </motion.p>

      {/* Our Location Section */}
      <motion.div 
        className={styles.locationSection}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.8 }}
      >
        <div className={styles.titleContainer}>
          <h2 className={styles.title}>Our Location</h2>
          <p className={styles.subtitle}>Get in Touch</p>
        </div>
        
        <div className={styles.locationContent}>
          <div className={styles.locationInfo}>
            <p>
              Our headquarters is located in Tampa, near University of South Florifa(USF). Our decision to remain in Tampa
              is rooted in both personal and professional reasons. Our development team is located in Tampa, which fosters collaboration and efficiency.
              In addition, for the past three years, we have been developing this website at the University of South Florida's library,
              and further established a connection to the local community and leveraging the resources available here. 
 
            </p>
            {/* <p>
              The FirstLand office features cutting-edge technology, including interactive property displays, 
              virtual reality stations for property tours, and AI-powered consultation areas where clients 
              can explore their real estate options in a comfortable and engaging setting.
            </p>
            <p>
              We invite you to visit us and experience firsthand how FirstLand is revolutionizing the real estate industry 
              with our unique blend of technology, expertise, and personalized service.
            </p> */}
            <div className={styles.address}>
              <h3>FirstLand Headquarters</h3>
              <p>Tampa</p>
              <p>FL, 33617, U.S</p>
              <p>Phone: (813) 438-4389869</p>
              <p>Email: Team@firstland.homes</p>
            </div>
          </div>
          
          <motion.video
            className={styles.video}
            controls
            playbackRate={1.25}
            defaultPlaybackRate={1.25}
            muted
            onLoadedMetadata={(e) => {
              e.target.playbackRate = 1.25;
            }}
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.3 }}
          >
            <source src={videoSample} type="video/mp4"></source>
          </motion.video>
        </div>
      </motion.div>
    </div>
  );
};

export default About;
